export function ServiceDescriptionPage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Service Description
                    </h2>
                    <p className="fs-8">
                      What the Yapamar platform provides and how the Service
                      operates.
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>1. Overview</h5>
                    <p>
                      Yapamar (&quot;the Service&quot;) is a
                      Software-as-a-Service (SaaS) platform developed and
                      operated by <strong>Yapamar OÜ (Yapamar)</strong> - the
                      platform provides advanced marketing and sales analytics
                      through <strong>Marketing Mix Modeling (MMM)</strong> and
                      statistical data analysis. Yapamar enables organizations
                      to understand the effectiveness of their marketing and
                      media investments across both online and offline channels,
                      supporting data-driven decision-making and strategic
                      budget optimization.
                    </p>

                    <h5>2. Core Functionality</h5>
                    <p>
                      Yapamar provides customers with access to the following
                      features:
                    </p>
                    <ul>
                      <li>
                        <strong>Marketing Mix Modeling (MMM):</strong>{' '}
                        Statistical modeling to measure and attribute sales or
                        KPI performance to different marketing and media
                        activities.
                      </li>
                      <li>
                        <strong>Automated Insights:</strong> Programmatic
                        analyses and recommendations to support media planning,
                        budget allocation, and optimization decisions.
                      </li>
                      <li>
                        <strong>Multi-Channel Data Integration:</strong>{' '}
                        Aggregation of online and offline marketing data into
                        unified, standardized datasets.
                      </li>
                      <li>
                        <strong>Dashboard and Reporting Tools:</strong>{' '}
                        Interactive dashboards and automated reports (PDF, CSV,
                        and online views) for real-time visibility into
                        performance.
                      </li>
                      <li>
                        <strong>Scenario Planning and Optimization:</strong>{' '}
                        Tools to simulate alternative media and budget scenarios
                        for both short- and long-term planning.
                      </li>
                    </ul>
                    <p>
                      Yapamar does{' '}
                      <strong>
                        not process or require any personal data (PII)
                      </strong>{' '}
                      for its modeling. All data used within the Service
                      consists of aggregated or anonymized datasets, ensuring
                      compliance with the{' '}
                      <strong>
                        EU General Data Protection Regulation (GDPR)
                      </strong>
                      .
                    </p>

                    <h5>3. Service Availability and Access</h5>
                    <p>
                      Yapamar is provided as a <strong>cloud-based SaaS</strong>{' '}
                      service, accessible through a secure web interface (
                      <a
                        href="https://yapamar.com"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://yapamar.com
                      </a>
                      ). The Service is available 24/7, excluding scheduled
                      maintenance or updates, which will be communicated in
                      advance. User authentication and access control are
                      managed through unique credentials provided to authorized
                      customer users. Yapamar follows best practices in
                      cybersecurity and data protection, including encryption in
                      transit and at rest.
                    </p>

                    <h5>4. Data Sources and Ownership</h5>
                    <p>
                      Customers retain full ownership of all data they provide
                      to Yapamar. Yapamar only processes customer data as
                      necessary to provide the Service, in accordance with the{' '}
                      <strong>Data Processing Agreement (DPA)</strong> between
                      the parties. Data sources may include:
                    </p>
                    <ul>
                      <li>Aggregated campaign performance data</li>
                      <li>Media spend data (digital and offline)</li>
                      <li>
                        External market indicators or publicly available
                        datasets
                      </li>
                      <li>
                        Customer-provided business KPIs (non-personal data)
                      </li>
                    </ul>
                    <p>
                      No personal or cookie-based tracking data is used for
                      modeling or analysis.
                    </p>

                    <h5>5. Service Updates and Support</h5>
                    <p>
                      Yapamar continuously improves the Yapamar platform.
                      Updates and feature enhancements are deployed
                      automatically to all customers and may include UI
                      improvements, modeling algorithm updates, or integration
                      enhancements. Technical and customer support is available
                      via{' '}
                      <a href="mailto:support@yapamar.com">
                        support@yapamar.com
                      </a>
                      .
                    </p>

                    <h5>6. Service Fees</h5>
                    <p>
                      The Service is billed as a{' '}
                      <strong>subscription-based model </strong>
                      in accordance with the pricing plans published on the
                      Yapamar website or the Customer’s Order Form. Unless
                      otherwise agreed, billing is monthly in advance and
                      subject to the <strong>Terms of Service</strong>.
                    </p>

                    <h5>7. Security and Compliance</h5>
                    <p>
                      Yapamar OÜ applies industry-standard security controls,
                      including:
                    </p>
                    <ul>
                      <li>Encrypted communication (TLS 1.2+)</li>
                      <li>Data encryption at rest (AES-256)</li>
                      <li>Regular system audits and monitoring</li>
                      <li>Strict access controls and logging</li>
                    </ul>
                    <p>
                      Since Yapamar operates solely on non-personal, aggregated
                      data, the Service is inherently{' '}
                      <strong>GDPR-compliant</strong> and does not require
                      end-user consent for modeling purposes.
                    </p>

                    <h5>8. Termination and Data Retention</h5>
                    <p>
                      Upon termination of the Customer’s subscription, Yapamar
                      will retain modeling and aggregated data for a maximum of{' '}
                      <strong>90 days</strong>, after which all customer-related
                      data will be permanently deleted, unless otherwise
                      required by law or mutual agreement.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
